import ReportSelect from "./ReportSelect";

function WaterKernelInit(props) {
  return <ReportSelect type={"water-kernel-initialization"} />;
}

export default WaterKernelInit;
